import { Controller } from "@hotwired/stimulus"
import { debounce, patchJson, sessionIdFor } from "./sweeper_shared"

export default class extends Controller {
  updateReady(event) {
    const field = event.target.closest('[name="verdict"]')
    if (!field || !this.sessionId) return

    field.closest(".verdict-radio").querySelectorAll("label").forEach(label => {
      label.classList.remove("checked", "ready", "needs")
    })
    field.parentElement.classList.add("checked", field.value)
    this.save({ ready: field.value, notes: this.notes })
  }

  updateNotes(event) {
    const field = event.target.closest('[data-verdict="notes"]')
    if (!field || !this.sessionId) return

    debounce(this, "verdict:notes", () => {
      this.save({ ready: this.ready, notes: field.value })
    })
  }

  save(body) {
    patchJson(`/api/v1/sessions/${encodeURIComponent(this.sessionId)}/verdict`, body)
  }

  get ready() {
    return this.element.querySelector('[name="verdict"]:checked')?.value || null
  }

  get notes() {
    return this.element.querySelector('[data-verdict="notes"]')?.value || ""
  }

  get sessionId() {
    return sessionIdFor(this.element)
  }
}
